(() => {
  const section = document.querySelector('[data-inkybox-related-products]');
  if (!section) return;

  const grid = section.querySelector('[data-related-products-grid]');
  const limit = Number(section.dataset.productsToShow) || 8;
  const currentProductId = String(section.dataset.productId || '');
  const currentHandle = String(section.dataset.productHandle || '');

  function appendRoundRobin(lists, targetCount, chosen, seen) {
    for (let index = 0; chosen.length < targetCount && lists.some((list) => index < list.length); index += 1) {
      for (const list of lists) {
        const candidate = list[index];
        const productId = candidate?.productId;
        if (!candidate || !productId || seen.has(productId)) continue;
        seen.add(productId);
        chosen.push(candidate);
        if (chosen.length === targetCount) break;
      }
    }
  }

  async function load() {
    if (!grid || !currentProductId || !window.InkyboxRelatedCatalog) return;

    try {
      const historyHandles = (window.InkyboxRecentlyViewed?.readHandles?.() || [])
        .filter((handle) => handle && handle !== currentHandle)
        .slice(0, 2);
      const [primarySource, historySources] = await Promise.all([
        window.InkyboxRelatedCatalog.resolve({
          sourceElement: section.querySelector('[data-related-metafield-source]'),
          productId: currentProductId,
          handle: currentHandle,
        }),
        Promise.all(historyHandles.map((handle) => window.InkyboxRelatedCatalog.resolve({ handle }))),
      ]);

      const historySlots = Math.min(2, Math.max(0, limit - 1));
      const seen = new Set([
        currentProductId,
        ...historySources.map((source) => source.anchorProductId).filter(Boolean),
      ]);
      const chosen = [];
      appendRoundRobin([primarySource.candidates], limit - historySlots, chosen, seen);
      appendRoundRobin(historySources.map((source) => source.candidates), limit, chosen, seen);
      appendRoundRobin([
        primarySource.candidates,
        ...historySources.map((source) => source.candidates),
      ], limit, chosen, seen);

      const cards = (await Promise.all(chosen.map((candidate) =>
        window.InkyboxRelatedCatalog.render(candidate, section.dataset.sectionId).catch(() => null)
      ))).filter(Boolean);
      grid.replaceChildren(...cards);
      section.hidden = !cards.length;
      if (cards.length) window.initInkyboxCardPreview?.(grid);
    } catch (error) {
      section.hidden = true;
      console.error(error);
    }
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    observer.disconnect();
    load();
  }, { rootMargin: '0px 0px 400px 0px' });

  observer.observe(section.parentElement?.querySelector('[data-related-products-sentinel]') || section.parentElement || section);
})();
